import { useParams } from "react-router";
import { SupplierForm } from "./SupplierForm";
import { useGetOneOrganization } from "src/api/client-api/company/useGetOneOrganization.ts";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

export const UpdateSupplierPage = () => {
    const { supplierId, startingPageId } = useParams();
    const { selectedCompany } = useFoodpilotContext();
    const { company, ...query } = useGetOneOrganization({
        companyId: supplierId,
        organizationId: selectedCompany?.id,
        enabled: selectedCompany !== null,
    });

    if (query.isFetched === false) {
        return null;
    }

    if (company === undefined) {
        // Should display an Error screen
        // It means the ID is wrong
        return null;
    }

    return <SupplierForm existingSupplier={company} startingPageId={startingPageId ?? "0"} />;
};
